import React from "react";
import HeadshotProps from "./type";
import classNames from "classnames";

export default function Headshot(props: HeadshotProps) {
  return (
    <div
      className={classNames("headshot", {
        [`headshot--${props.size}`]: !props.dimension && props.size,
        "headshot--withPicture": props.imageLocation
      })}
      style={{ height: props.dimension?.height, width: props.dimension?.width }}>
      {props.imageLocation ? (
        <img src={props.imageLocation} alt="headshot" />
      ) : (
        <span className="headshot--initial">{props.nameInitials}</span>
      )}
    </div>
  );
}
